import React from "react";
import CmsPage from "../CmsPage/CmsPage";
import "./Socialresponsibility.scss";

const Socialresponsibility = () => {
  return <CmsPage id={9} />;
};

export default Socialresponsibility;
